import { AppBar, Button, Container, Divider, Grid, Link, Paper, Toolbar, Typography } from "@mui/material";
import { useMediaQuery } from 'react-responsive'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import logo from './RestoFinalLogo.png';
import industry from './RestoIndustry4.png';
import industry2 from './RestoIndustry44.png';
import startup from './startupIndia.jpg';
import { styled } from '@mui/material/styles';
import { purple, teal, blue,indigo,blueGrey } from "@mui/material/colors";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import React, {useState} from 'react';
import restologo from './restologo.png';
import slogan1 from './slogan1.png';
import { isMobilePhone } from "validator";



const HomePage = props => {

    const signInButtonHandler = () => {
        props.loginPageStateChange({loginPageState : true})
        props.homePageStateChange({homePageState:false})
        
    }

    function Copyright(props) {
        return (
          <Typography variant="body2" color="#212121" align="center" {...props}>
            {'Copyright © '}
            <Link color="#424242" href="https://ndfmbusinessworld.com/">
              NDFM Business World Private Limited
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
          </Typography>
        );
      }

    const ColorButton = styled(Button)(({ theme }) => ({
        color: theme.palette.getContrastText(teal[900]),
        backgroundColor: blueGrey[800],
        '&:hover': {
          backgroundColor: blueGrey[700],
        },
      }));

    const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1224px)'})
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })


    let passPropertiesToChild = {
       
    }


  return(
     
    <ThemeProvider
    theme={createTheme({
      components: {
        MuiListItemButton: {
          defaultProps: {
            disableTouchRipple: true,
          },
        },
      },
      palette: {
        mode: 'light',
        primary: { main: '#eceff1' },
        background: { paper: '#eceff1' },
        button : "#b0bec5"
      },
    })}
  >

    {isDesktopOrLaptop && (
      <React.Fragment>
       
       <AppBar elevation={0} >
         <Toolbar disableGutters>
           
         <Grid sx={{pt:1, pb:0,mx:4,my:2}}container spacing={0}  alignItems="center" justifyContent="flex-start">

         <Grid item  xs={12} sm={4.5} >
              <img  src={logo} alt="" style={{ width:"55%"}}/>
          </Grid>

          <Grid item  xs={12} sm={3} >
              <img  src={restologo} alt="" style={{ width:"38%"}}/>
          </Grid>

             <Grid item xs={12} sm={4.5} sx={{mb:1}}>
             <Grid container spacing={0}  alignItems="center" justifyContent="flex-end">
             <Grid item xs="auto">
             <ColorButton startIcon={<AccountCircleIcon />} variant="contained" onClick={signInButtonHandler}>Create Account / Sign in</ColorButton>
             </Grid>
             </Grid>
             </Grid>    

       </Grid>
         </Toolbar>
       
     </AppBar>


<Grid sx={{mt:15,p:4}}container spacing={2}  alignItems="center" justifyContent="flex-start">
<Grid item  xs={12} sm={1} ></Grid>
<Grid item  xs={12} sm={5} >
<img  src={industry} alt="" style={{ width:"100%"}}/>
          </Grid>
          <Grid item  xs={12} sm={0.5} ></Grid>
          <Grid item  xs={12} sm={4.5} >
            <Typography align="center" variant="h4">Create Account / Sign in to begin with RestoHandle free trial for 15 days.</Typography>
            <Typography sx={{mt:1}} align="center" variant="h4">Free of cost with zero payment!</Typography>
            <Typography align="center">
              <ColorButton size="large" sx={{mt:2}} startIcon={<AccountCircleIcon />} variant="contained" onClick={signInButtonHandler}>Create Account / Sign in
              </ColorButton>
              </Typography>
          </Grid>
          <Grid item  xs={12} sm={1} ></Grid>


<Grid item  xs={12} sm={12} >
<img  src={industry2} alt="" style={{ width:"100%"}}/>
             
          </Grid>


          <Grid item  xs={12} sm={12} >
<Divider sx={{my:2}} />
</Grid>

          <Grid item  xs={12} sm={5.5} >
<img  src={startup} alt="" style={{ width:"100%"}}/>
             
          </Grid>

          <Grid item  xs={12} sm={0.5} ></Grid>
          <Grid item  xs={12} sm={5.5} >
            <Paper sx={{p:3}} elevation={0}>
    <Typography align="center" variant="h6"  sx={{textDecoration: 'underline',mb:1}}>
          About Our Software Company
    </Typography>

    <Typography align="center" color="#004d40" variant="h4" sx={{mb:1}}>
          NDFM BUSINESS WORLD PVT. LTD.
    </Typography>

    <Typography align="center" variant="body1" sx={{mb:1}}>
    Our software company specializes in creating innovative, high-quality software solutions tailored to meet the needs of businesses across various industries. With a strong focus on user experience, scalability, and cutting-edge technology, we develop applications that drive efficiency and growth. Our team of skilled developers, designers, and marketers work collaboratively to deliver products that solve complex challenges and enhance productivity. Whether it’s custom software development, mobile applications, or SaaS platforms, we are committed to excellence and customer satisfaction. Our company is dedicated to staying ahead of industry trends, ensuring that our clients receive the most advanced and effective solutions available. 
    </Typography>

    <Typography align="center" color="#004d40" variant="h6" sx={{mb:1}}>
          Visit our website to discover more about us!
    </Typography>
    <Typography align="center">
    <Link color="#424242" href="https://ndfmbusinessworld.com/">
              <ColorButton size="large" sx={{mt:0.5}}  variant="contained" >Visit our website
              </ColorButton>
              </Link>
              </Typography>
             
    <Grid item  xs={12} sm={0.5} ></Grid>
    </Paper>
          </Grid>


          </Grid>

           
          </React.Fragment>
    )}





{isTabletOrMobile && (
      <React.Fragment>
       
       <AppBar elevation={0} >
         <Toolbar disableGutters>
           
         <Grid sx={{pt:1, pb:0,mx:4,my:2}}container spacing={0}  alignItems="center" justifyContent="flex-start">

         <Grid item  xs={12} sm={4.5} >
              <img  src={logo} alt="" style={{ width:"55%"}}/>
          </Grid>

          <Grid item  xs={12} sm={3} >
              <img  src={restologo} alt="" style={{ width:"38%"}}/>
          </Grid>

             <Grid item xs={12} sm={4.5} sx={{mb:1}}>
             <Grid container spacing={0}  alignItems="center" justifyContent="center">
             <Grid item xs="auto">
             <ColorButton startIcon={<AccountCircleIcon />} variant="contained" onClick={signInButtonHandler}>Create Account / Sign in</ColorButton>
             </Grid>
             </Grid>
             </Grid>    

       </Grid>
         </Toolbar>
       
     </AppBar>


<Grid sx={{mt:25,p:4}}container spacing={2}  alignItems="center" justifyContent="flex-start">
<Grid item  xs={12} sm={1} ></Grid>
<Grid item  xs={12} sm={5} >
<img  src={industry} alt="" style={{ width:"100%"}}/>
          </Grid>
          <Grid item  xs={12} sm={0.5} ></Grid>
          <Grid item  xs={12} sm={4.5} >
            <Typography align="center" variant="body1">Create Account / Sign in to begin with RestoHandle free trial for 15 days.</Typography>
            <Typography sx={{mt:1}} align="center" variant="h6">Free of cost with zero payment!</Typography>
            <Typography align="center">
              <ColorButton size="large" sx={{mt:2}} startIcon={<AccountCircleIcon />} variant="contained" onClick={signInButtonHandler}>Create Account / Sign in
              </ColorButton>
              </Typography>
          </Grid>
          <Grid item  xs={12} sm={1} ></Grid>


<Grid item  xs={12} sm={12} >
<img  src={slogan1} alt="" style={{ width:"100%"}}/>
             
          </Grid>


          <Grid item  xs={12} sm={12} >
<Divider sx={{my:2}} />
</Grid>

          <Grid item  xs={12} sm={5.5} >
<img  src={startup} alt="" style={{ width:"100%"}}/>
             
          </Grid>

          <Grid item  xs={12} sm={0.5} ></Grid>
          <Grid item  xs={12} sm={5.5} >
            <Paper sx={{p:3}} elevation={0}>
    <Typography align="center" variant="h6"  sx={{textDecoration: 'underline',mb:1}}>
          About Our Software Company
    </Typography>

    <Typography align="center" color="#004d40" variant="h4" sx={{mb:1}}>
          NDFM BUSINESS WORLD PVT. LTD.
    </Typography>

    <Typography align="center" variant="body1" sx={{mb:1}}>
    Our software company specializes in creating innovative, high-quality software solutions tailored to meet the needs of businesses across various industries. With a strong focus on user experience, scalability, and cutting-edge technology, we develop applications that drive efficiency and growth. Our team of skilled developers, designers, and marketers work collaboratively to deliver products that solve complex challenges and enhance productivity. Whether it’s custom software development, mobile applications, or SaaS platforms, we are committed to excellence and customer satisfaction. Our company is dedicated to staying ahead of industry trends, ensuring that our clients receive the most advanced and effective solutions available. 
    </Typography>

    <Typography align="center" color="#004d40" variant="h6" sx={{mb:1}}>
          Visit our website to discover more about us!
    </Typography>
    <Typography align="center">
    <Link color="#424242" href="https://ndfmbusinessworld.com/">
              <ColorButton size="large" sx={{mt:0.5}}  variant="contained" >Visit our website
              </ColorButton>
              </Link>
              </Typography>
             
    <Grid item  xs={12} sm={0.5} ></Grid>
    </Paper>
          </Grid>


          </Grid>

           
          </React.Fragment>
    )}
    
    
    <Divider sx={{m:4,mx:10,mt:3,mb:4}}/>

    <Copyright/>

    <Grid sx={{mt:1,pb:4}}container spacing={2}  alignItems="center" justifyContent="center">
   
    <Grid item  xs={12} sm={12} >
    <Typography align="center">
    <Link color="#424242" href="https://ndfmbusinessworld.com/online-contact-form">
              Contact Us
            </Link>
            </Typography>
            </Grid>
            </Grid>
           
           



            
    </ThemeProvider>
    
  );
}   

export default HomePage;